/* took2 – Live Totals für Warenkorb (Subtotal & Estimated Total) */
(() => {
  const CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const LOCALE   = document.documentElement.lang?.toLowerCase().startsWith('de') ? 'de-DE' : 'en-US';

  const fmt = (cents) =>
    (cents/100).toLocaleString(LOCALE, { style:'currency', currency:CURRENCY });

  /* ---- Preis in Ziel-Element schreiben (robust) ---- */
  function setPrice(target, cents){
    if (!target) return;
    const child = target.querySelector('.money, [data-money-convertible], [data-price]');
    const txt   = fmt(cents);
    if (child) child.textContent = txt;
    else target.textContent = txt;
  }

  /* ---- Update aller bekannten Total-Ziele ---- */
  async function updateTotals(){
    try{
      const cart = await (await fetch('/cart.js', {cache:'no-store'})).json();
      const subtotal = cart.items_subtotal_price;
      const total    = cart.total_price; // „Geschätzte Gesamtkosten“ auf vielen Themes

      // Subtotal-Ziele
      const subtotalTargets = document.querySelectorAll(
        [
          '[data-cart-subtotal]',
          '.totals__subtotal-value',
          '#cart-subtotal',
          '[data-subtotal]',
          '[data-checkout-subtotal-price-target]',
          '[data-cart-subtotal-price]',
          '.cart__subtotal .price',
          '.cart__footer .totals .price'
        ].join(',')
      );
      subtotalTargets.forEach(el => setPrice(el, subtotal));

      // Estimated Total / Payment due Ziele
      const totalTargets = document.querySelectorAll(
        [
          '[data-cart-total]',
          '.totals__total-value',
          '[data-checkout-payment-due-target]',
          '.payment-due__price',
          '.cart-estimated-total',
          '.cart-total',
          '.cart__footer .payment-due__price'
        ].join(',')
      );
      totalTargets.forEach(el => setPrice(el, total));
    }catch(e){ console.warn('t2 totals update failed', e); }
  }

  /* ---- Fallback: auf jede Qty-Aktion neu rechnen ---- */
  function onClick(e){
    const isPlus  = !!e.target.closest(
      '.quantity__button[name="plus"], [name="plus"], .quantity__button--plus, [data-action="increment"]'
    );
    const isMinus = !!e.target.closest(
      '.quantity__button[name="minus"], [name="minus"], .quantity__button--minus, [data-action="decrement"]'
    );
    if (isPlus || isMinus) {
      // kurze Verzögerung, damit Theme sein DOM aktualisiert; dann Totals ziehen
      setTimeout(updateTotals, 120);
    }
  }
  function onChange(e){
    if (e.target.matches('.quantity__input, input[name*="updates"], input[type="number"]')) {
      setTimeout(updateTotals, 120);
    }
  }

  /* ---- Beobachter: wenn das Theme Zeilen austauscht ---- */
  function observe(){
    const form = document.querySelector('form[action="/cart"]') || document.body;
    if (!form) return;
    const mo = new MutationObserver(() => { setTimeout(updateTotals, 50); });
    mo.observe(form, { subtree:true, childList:true, characterData:true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateTotals();           // initial
    observe();                // DOM-Änderungen mitnehmen
    document.addEventListener('click',  onClick,  true);
    document.addEventListener('change', onChange, true);
  });
})();
